import { MerchandisingTag, TasteProfile } from 'src/gqlReactTypings.generated.d';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createSelectors } from './create-selectors';

interface Actions {
  setFilters: (values: TasteProfile) => void;
  clearFilters: () => void;
  updateFilters: (values: Partial<TasteProfile>) => void;
  getFilters: () => TasteProfile;
  setSelectedMerchandisingTag: (tag: MerchandisingTag | null) => void;
}

interface State {
  filters: TasteProfile;
  selectedMerchandisingTag: MerchandisingTag | null;
}

const INITIAL_FILTERS_DATA: TasteProfile = {
  dietType: undefined,
  preferredProteins: [],
  menuDietaryRestrictions: [],
  cuisinePreferences: [],
  replacementDietaryRestrictions: [],
  numAdults: undefined,
  numBigEaters: undefined,
  numLittleEaters: undefined,
};

const INITIAL_STATE: State = {
  filters: INITIAL_FILTERS_DATA,
  selectedMerchandisingTag: null,
};

export const useTasteProfileFiltersStore = create(
  persist<State & Actions>(
    (set, get) => ({
      ...INITIAL_STATE,
      setFilters: (values) => set({ filters: values }),
      updateFilters: (values) => set((state) => ({ filters: { ...state.filters, ...values } })),
      clearFilters: () => set({ filters: INITIAL_FILTERS_DATA, selectedMerchandisingTag: null }),
      getFilters: () => get().filters,
      setSelectedMerchandisingTag: (tag) => set({ selectedMerchandisingTag: tag }),
    }),
    {
      name: 'taste-profile-filters-store',
      getStorage: () => localStorage,
    }
  )
);

export const useTasteProfileFiltersStoreSelectors = createSelectors(useTasteProfileFiltersStore);
